import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { Route, Redirect } from 'react-router-dom';

const UserProfileRoute = ({ component: Component, auth, userId, ...rest }) => {

    return (
        <Route {...rest} render={props => {
            // if ((auth.user.id != userId) && !(auth.isAdmin || auth.isProjectManager)) {
            //     return <Redirect to={{ pathname: '/' }} />
            // }

            return (
                <>
                    <Component {...props} />
                </>
            )
        }} />
    )
}

const mapStateToProps = (state) => ({
    auth: state.auth
})

export default connect(mapStateToProps, null)(UserProfileRoute)